// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { Button } from "@components";
import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import * as sharedSelectors from "@modules/shared/selectors";
import type {
  DynamicQuestion,
  DynamicQuestionContent,
} from "@modules/service/reducer/dynamic-questions/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { StepProps } from "@components";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment, ApprovableContainer } from "@modules/service/types";

type PropsFromState = $Exact<{
  container: ?DynamicQuestion,
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
  isAssignmentsValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreators.SetDynamicQuestionAssignments,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step2HierarchyScope extends React.Component<Props> {
  handleChanges = (formData: Array<HierarchyAssignment>) => {
    this.props.setAssignments(formData);
  };

  handleHierarchyScopeNext = () => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit({}, true);
    }
  };

  render() {
    if (!this.props.editable) {
      return null;
    }
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy && this.props.assignments ? (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.props.assignments}
              onChange={this.handleChanges}
            />
          ) : null}
          <div className="w-100 d-flex justify-content-end mt-5 mb-3">
            <Button
              materialIcon="fast_forward"
              onClick={this.handleHierarchyScopeNext}
              disabled={!this.props.isAssignmentsValid}
            >
              {this.props.t("NEXT")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    container: serviceSelectors.getDynamicQuestionContainer(state),
    assignments: serviceSelectors.getDynamicQuestionAssignments(state),
    isAssignmentsValid: serviceSelectors.isDynamicQuestionAssignmentsValid(state),
    hierarchy: sharedSelectors.getHierarchyTree(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreators.SetDynamicQuestionAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step2HierarchyScope);
